import React, {useState, useEffect} from 'react'
import {useParams} from 'react-router-dom'



const ContactTPVAdmin = () => {
    const [role, setRole] = useState<any>('')

    const getUserParams = useParams()

    useEffect(() => {
        const roleValue: any = getUserParams.adminUser
        setRole(roleValue)
      }, [getUserParams])

    const openEmailClient = () => {
       window.open('mailto:hello@tpvsolutions.com?subject=Feedback&body=Body%20goes%20here')
    }
    
  return (
    <>{ role !== 'tpvadmin' ?
       (<div className='text-gray-500 text-center fw-semibold fs-6 pb-0'>
       Don't have an account? <a onClick={openEmailClient}  className='link-primary' style={{cursor:'pointer'}}> Contact TPV admin</a></div>) : ('')
    }</>
  )
}

export default ContactTPVAdmin
